import { Code, Hint, Link, Radio } from '@lokalise/louis';

interface FilenamesOriginalRadioProps {
    isLimitedFileStructure: boolean;
}

const FilenamesOriginalRadio = ({ isLimitedFileStructure }: FilenamesOriginalRadioProps) => (
    <Radio value="filenamesOriginal">
        {isLimitedFileStructure
            ? 'Use previously assigned filenames'
            : 'Multiple files per language (use assigned filenames). Directory prefix:'}{' '}
        <Hint placement="right">
            {isLimitedFileStructure ? (
                <>
                    Split keys by files as defined in key properties.{' '}
                    <Link
                        target="_blank"
                        rel="noreferrer"
                        href="https://docs.lokalise.com/en/articles/3150682-downloading-translation-files#h_e3de55edb6"
                    >
                        Learn more
                    </Link>
                    .
                </>
            ) : (
                <>
                    Split keys by files as defined in key properties. We will add the provided prefix in the bundle
                    structure if required. Use <Code>%LANG_ISO%</Code> placeholder to rotate language codes.{' '}
                    <Link
                        target="_blank"
                        rel="noreferrer"
                        href="https://docs.lokalise.com/en/articles/3150682-downloading-translation-files#h_e3de55edb6"
                    >
                        Learn more
                    </Link>
                    .
                </>
            )}
        </Hint>
    </Radio>
);

export default FilenamesOriginalRadio;
